import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom"
import { ShutdownPage } from "./ShutdownPage"

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="*" element={<ShutdownPage />} />
  )
)
